import { render, staticRenderFns } from "./rightBox.vue?vue&type=template&id=bdd57230&scoped=true"
import script from "./rightBox.vue?vue&type=script&lang=js"
export * from "./rightBox.vue?vue&type=script&lang=js"
import style0 from "./rightBox.vue?vue&type=style&index=0&id=bdd57230&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdd57230",
  null
  
)

export default component.exports